import { TeamMemberGridStandard } from "../../../../modules/team-member-grid/components/TeamMemberGridStandard/TeamMemberGridStandard";
import type { ITeamMemberGridBlockProps } from "./TeamMemberGridBlock.props";

export const TeamMemberGridBlock = (props: ITeamMemberGridBlockProps) => {
  if (!props.items?.length) {
    return null;
  }

  return <TeamMemberGridStandard {...props} />;
};

TeamMemberGridBlock.displayName = "Block::TeamMemberGridBlock";
